import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const API = process.env.REACT_APP_API_URL || "";

const SORTS = [
  { value: "rating", label: "Rating" },
  { value: "kd", label: "K/D" },
  { value: "adr", label: "ADR" },
  { value: "kast", label: "KAST" },
  { value: "kills", label: "Kills" },
];

export default function Leaderboard() {
  const [data, setData] = useState([]);
  const [sort, setSort] = useState("rating");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${API}/api/leaderboard?sort=${sort}`)
      .then((r) => setData(r.data.leaderboard || []))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [sort]);

  return (
    <div>
      <h1>🏆 Leaderboard</h1>
      <div className="card">
        <div style={{ display: "flex", gap: "0.5rem", marginBottom: "1rem", flexWrap: "wrap" }}>
          {SORTS.map((s) => (
            <button
              key={s.value}
              onClick={() => setSort(s.value)}
              style={{
                padding: "0.35rem 1rem",
                borderRadius: "6px",
                border: "none",
                cursor: "pointer",
                background: sort === s.value ? "#f0a500" : "#2d3148",
                color: sort === s.value ? "#0f1117" : "#e5e7eb",
                fontWeight: sort === s.value ? "700" : "400",
              }}
            >
              {s.label}
            </button>
          ))}
        </div>

        {loading ? (
          <p style={{ color: "#9ca3af" }}>Loading...</p>
        ) : data.length === 0 ? (
          <p style={{ color: "#9ca3af" }}>No data yet. Play some matches!</p>
        ) : (
          <table className="table">
            <thead>
              <tr>
                <th>#</th>
                <th>Player</th>
                <th>Matches</th>
                <th>K/D</th>
                <th>ADR</th>
                <th>KAST %</th>
                <th>Rating</th>
              </tr>
            </thead>
            <tbody>
              {data.map((row, i) => (
                <tr key={row.steam_id}>
                  <td style={{ color: i < 3 ? "#f0a500" : "#9ca3af" }}>
                    {i === 0 ? "🥇" : i === 1 ? "🥈" : i === 2 ? "🥉" : i + 1}
                  </td>
                  <td>
                    <Link to={`/players/${row.steam_id}`}>{row.name}</Link>
                  </td>
                  <td>{row.matches_played}</td>
                  <td>{row.kd_ratio}</td>
                  <td>{row.avg_adr}</td>
                  <td>{row.avg_kast}%</td>
                  <td style={{ color: "#f0a500", fontWeight: "600" }}>{row.avg_rating}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
